import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/payments/:parkingId/payment-orders/:paymentOrderNumber/digital-receipt/';

type OnlinePaymentReceipt = {
    details: string;
};

interface DTO {
    parkingId: string;
    paymentOrderNumber: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, paymentOrderNumber }: DTO): Promise<OnlinePaymentReceipt> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, paymentOrderNumber }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetOnlinePaymentReceipt };
